import { Service } from "typedi";
import { Repository } from "./repository";
import { IOptions } from "../interfaces/options.interface";

@Service()
export class OptionsRepository extends Repository<IOptions> {
    clazz = undefined
    key = "options"
}
